<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      v-if="
        $route.name == 'list-cascade-fields'"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="updateCampaignCascadedFields"
    />
     <feather-icon
      v-if="
        $route.name == 'list-cascade-fields'"
      icon="TrashIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="deleteCampaignCascadedFields"
    />
  </div>
</template>

<script>
import axios from "@/axios.js";
export default {
  name: "CellRendererActions",
  data() {
    return {
      selected_account: null
    };
  },
  methods: {
    updateCampaignCascadedFields() {
      this.$parent.$parent.updateCampaignCascadedFields(this.params.data);
    },
        deleteCampaignCascadedFields() {
      this.$parent.$parent.deleteCampaignCascadedFields(this.params.data);
    },
  },
  beforeMount() {},
  created() {}
};
</script>
